import Box from '@components/Box';
import PlacingOrderAddressDropdownItem
  from '../PlacingOrderAddressDropdownItem/PlacingOrderAddressDropdownItem';
import SelectDropdown from '@components/SelectDropdown';
import TextInputContainer from '@containers/TextInputContainer';
import TextInputWithSuggestionsContainer from '@containers/TextInputWithSuggestionsContainer';
import { AddressTemplate, TLabelSelectedItem } from '@api/apiClient';
import { Column, Row } from '@components/Grid';
import { IPlacingOrderAddressFieldsSecondProps } from '../../placing-types';
import { TSuggestionTR } from '@api/apiClient/address';
import { useTranslation } from 'react-i18next';
import {
  TSuggestionTRByIndex,
} from '@api/apiClient/address';

const PlacingOrderAddressFieldsSecond: React.FC<IPlacingOrderAddressFieldsSecondProps> = (props: IPlacingOrderAddressFieldsSecondProps): React.ReactElement => {
  const {
    city,
    control,
    emptyAddressWithUpdate,
    fullListAddresses,
    handlerGetFullAddress,
    handlerOnClickDeleteAddress,
    handlerSetCurrentAddress,
    handlerSetSelectedSuggestion,
    handlerSetSelectedSuggestionByIndex,
    labelSelectedItem,
    street,
    useSuggestions,
    useSuggestionsByIndex,
    zipCode
  } = props;

  const { t } = useTranslation();

  const getAddrStringByidx = (value: TSuggestionTRByIndex) => `${value?.postalCode} ${value?.city || ''}`;
  const getAddrString = (value: TSuggestionTR) => `${value?.postalCode} ${value?.city || ''} ${value?.street || ''} ${value?.houseNumber || ''} ${value?.apartment || ''}`

  return (
      <>
        <Row>
          <Column phone={12}>
            <Box mb={5}>
              <SelectDropdown<AddressTemplate>
                  defaultSelectedItem={emptyAddressWithUpdate}
                  items={fullListAddresses}
                  keyExtractor={(item: TLabelSelectedItem) => item.id}
                  label={t('placingOrderModalWindow.form.address.addressTitleSender')}
                  labelSelectedItem={() => handlerGetFullAddress(labelSelectedItem)}
                  onItemSelect={(id: string) => handlerSetCurrentAddress(id)}
                  renderItem={(props: { item: TLabelSelectedItem }) => (
                      <PlacingOrderAddressDropdownItem
                          handlerGetFullAddress={handlerGetFullAddress}
                          handlerOnClickDeleteAddress={handlerOnClickDeleteAddress}
                          {...props}
                      />
                  )}
              />
            </Box>
          </Column>
        </Row>
        <Row>
          <Column phone={5}>
            <Box
                mb={5}
                pr={4}
            >
              <TextInputWithSuggestionsContainer
                  control={control}
                  getName={getAddrStringByidx}
                  getSelectionValue={getAddrStringByidx}
                  name="address.zipCode"
                  onInput={() => (handlerSetSelectedSuggestionByIndex && handlerSetSelectedSuggestionByIndex(undefined))}
                  onSelect={handlerSetSelectedSuggestionByIndex}
                  title={t('placingOrderModalWindow.form.address.zipCode')}
                  useSuggestions={useSuggestionsByIndex}
              />
            </Box>
          </Column>
          <Column phone={7}>
            <Box mb={5}>
              <TextInputContainer
                  control={control}
                  disabled={!zipCode}
                  disabledMessage={t("placingOrderModalWindow.form.address.disableTooltip")}
                  name="address.city"
                  title={t('placingOrderModalWindow.form.address.city')}
              />
            </Box>
          </Column>
        </Row>
        <Row>
          <Column phone={12}>
            <Box mb={5}>
              <TextInputWithSuggestionsContainer
                control={control}
                getName={getAddrString}
                getSelectionValue={getAddrString}
                name="address.street"
                onInput={() => (handlerSetSelectedSuggestion && handlerSetSelectedSuggestion(undefined))}
                onSelect={handlerSetSelectedSuggestion}
                title={t('placingOrderModalWindow.form.address.street')}
                useSuggestions={useSuggestions}
                disabled={!zipCode || !city}
                disabledMessage={t("placingOrderModalWindow.form.address.disableTooltipCity")}
              />
            </Box>
          </Column>
        </Row>
        <Row>
          <Column phone={2}>
            <Box
                mb={8}
                pr={4}
            >
              <TextInputContainer
                  control={control}
                  disabled={!zipCode || !city || !street}
                  disabledMessage={t("placingOrderModalWindow.form.address.disableTooltipStreet")}
                  name="address.house"
                  title={t('placingOrderModalWindow.form.address.house')}
              />
            </Box>
          </Column>
          <Column phone={3}>
            <Box
                mb={8}
                pr={4}
            >
              <TextInputContainer
                  control={control}
                  disabled={!zipCode || !city || !street}
                  disabledMessage={t("placingOrderModalWindow.form.address.disableTooltipStreet")}
                  name="address.flat"
                  title={t('placingOrderModalWindow.form.address.flat')}
              />
            </Box>
          </Column>
        </Row>
      </>
  );
};

export default PlacingOrderAddressFieldsSecond;
